<div class="spinner_all" *ngIf="this.context.api.spinner.show">
  <div>
    <img src="assets/img/loadinfo.net.gif" alt="" />
  </div>
</div>
<banner-main-component></banner-main-component>
<router-outlet></router-outlet>

